
export class DiagnosticDataRequest {
    public ids: string[];
    public vin: string;
    
    constructor(vin?: string, ids?: string[]) {
        this.vin = vin ?? '';
        this.ids = ids ?? [];
    }
}
